import React from "react";
import { Typography, Button, Dropdown, Select, Space, Checkbox } from "antd";
import moment from "moment";
import {
  LeftOutlined,
  RightOutlined,
  DownOutlined,
  PrinterOutlined,
  UserSwitchOutlined,
  CheckSquareOutlined,
} from "@ant-design/icons";
import { useIntl } from "react-intl";
const { Title, Text } = Typography;
const { Option } = Select;

const Header = (props) => {
  const {
    currentMonth,
    onNextMonth,
    onPreviousMonth,
    visits,
    onShowTransferClick,
    onPrint,
    branchId,
    onPrintAllVisits,
    onVerifyVisits,
    type,
    setFilter,
    filter,
    setShowLocalId,
    showLocalId,
  } = props;
  const intl = useIntl();
  let date = moment(currentMonth).format("MMMM YYYY");

  const handleMenuClick = (e, record) => {
    switch (e.key) {
      case "1":
        onPrint();
        break;
      case "2":
        onTransferHouseVisits();
        break;
      case "3":
        onPrintAllVisits();
        break;
      case "4":
        onVerifyVisits();
        break;
      default:
        break;
    }
  };
  const onTransferHouseVisits = () => {
    onShowTransferClick();
  };

  const filterList = [
    {
      name: "exception_visits",
    },
    {
      name: "approved_visits",
    },
    {
      name: "not_verified_visits",
    },
  ];

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        paddingBottom: "10px",
        justifyContent: "space-between",
      }}
    >
      <Space>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            width: "200px",
          }}
        >
          <Button
            type="text"
            shape="circle"
            icon={<RightOutlined />}
            onClick={onPreviousMonth}
          />
          <Title level={4} style={{ margin: "0px", lineHeight: 1.5 }}>
            {date}
          </Title>
          <Button
            type="text"
            shape="circle"
            icon={<LeftOutlined />}
            onClick={onNextMonth}
          />
        </div>

        <Select
          style={{ width: 150 }}
          onChange={(val) => setFilter(val)}
          placeholder={intl.formatMessage({
            id: `app.house_visits.filter_visits`,
          })}
          value={filter}
          allowClear={true}
        >
          {filterList.map((option) => (
            <Option key={option.name} value={option.name}>
              {intl.formatMessage({
                id: `app.house_visits.${option.name}`,
              })}
            </Option>
          ))}
        </Select>

        <Checkbox
          style={{ margin: "0 20px" }}
          onChange={(e) => setShowLocalId(e.target.checked)}
          checked={showLocalId}
        >
          {intl.formatMessage({
            id: `app.house_visits.show_local_id`,
          })}
        </Checkbox>
      </Space>

      <div>
        <Text style={{ alignSelf: "center" }}>
          <span style={{ fontWeight: "bold" }}>{`${
            visits && visits.length
          } `}</span>
          {type === "houseVisits"
            ? intl.formatMessage({
                id: "app.house_visits.month_planned_total",
              })
            : intl.formatMessage({
                id: "app.house_visits.month_Waiting_for_verify_total",
              })}
        </Text>
        {visits && visits.length > 0 && type === "houseVisits" ? (
          <Dropdown
            trigger={["click"]}
            menu={{
              items: [
                {
                  label: intl.formatMessage({
                    id: "app.house_visits.print_house_visits_report",
                  }),
                  key: "1",
                  icon: <PrinterOutlined />,
                },
                {
                  label: intl.formatMessage({
                    id: "app.house_visits.transfer_house_visits",
                  }),
                  key: "2",
                  icon: <UserSwitchOutlined />,
                  disabled: branchId === undefined,
                },
                {
                  label: intl.formatMessage({
                    id: "app.house_visits.verifyAll",
                  }),
                  key: "4",
                  icon: <UserSwitchOutlined />,
                },
                {
                  label: intl.formatMessage({
                    id: "app.house_visits.print_all_visits",
                  }),
                  key: "3",
                  icon: <PrinterOutlined />,
                },
              ],
              onClick: (e) => handleMenuClick(e),
            }}
          >
            <Button type="link">
              {intl.formatMessage({
                id: "app.salary.options",
              })}
              <DownOutlined />
            </Button>
          </Dropdown>
        ) : visits && visits.length > 0 ? (
          <Button
            style={{ margin: "0 10px" }}
            type="primary"
            onClick={onVerifyVisits}
            size="large"
          >
            <CheckSquareOutlined />{" "}
            {intl.formatMessage({
              id: "app.house_visits.verifyAll",
            })}
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default Header;
